import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validar que la configuración esté completa
const validateConfig = () => {
  const requiredKeys = ['apiKey', 'authDomain', 'projectId'] as const;
  const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);
  
  if (missingKeys.length > 0) {
    console.error(`Firebase config missing required keys: ${missingKeys.join(', ')}`);
    return false;
  }
  return true;
};

// Initialize Firebase with error handling
let app;
try {
  if (validateConfig()) {
    app = initializeApp(firebaseConfig);
    console.log('Firebase initialized successfully');
  } else {
    throw new Error('Invalid Firebase configuration');
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  // Crear una app con configuración mínima para evitar errores
  app = initializeApp({
    apiKey: 'demo-key',
    authDomain: 'demo-app.firebaseapp.com',
    projectId: 'demo-app',
  });
}

// Initialize Firebase Authentication with error handling
export const auth = getAuth(app);

// Configurar persistencia para evitar problemas de transacción
setPersistence(auth, browserLocalPersistence).catch(error => {
  console.error('Error setting auth persistence:', error);
});

// Using cloud Firebase authentication instead of emulator
// Uncomment to use emulator
// if (import.meta.env.DEV) {
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   console.log('Using Firebase Auth Emulator');
// }

export default app;